import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

///////////USER PANEL//////////
import Home from "../User/Home/homepage";
import UploadInfo from "../User/Home/form";
import Scanner from "../User/Scanner/qrcodescanner";
import ZoneSelection from "../User/Zone/zoneselection";
import Music from "../User/Zone/music/music";
import AiArtifacts from "../User/Zone/AiArtifacts/AiArtifact";
import WorldReligion from "../User/Zone/WorldReligion/wr";
import SanatanDharma from "../User/Zone/SanatanDharma/sanatan";
import CharlieChaplin from "../User/Zone/OtherVideos/charlinchaplin";
import ThreeDVideos from "../User/Zone/OtherVideos/3d";
import Steam from "../User/Zone/OtherVideos/steam";
import DanceForm from "../User/Zone/OtherVideos/danceform";
import Colour from "../User/Zone/OtherVideos/colour";
import Background from "../User/Zone/BackgroundMoods/background";
import SaarMusic from "../User/Zone/SanatanSaar/saar";
import BeatsMusic from "../User/Zone/SanatanBeats/beats";
import ZoneTable from "../User/Zone/ZonetablePoster/zonetable";
import ZoneScan from "../User/Zone/ZoneScanner/zonescan";
import CodeScanner from "../User/Zone/MusicScanner/codescanner";
import HolocodeScan from "../User/Zone/HoloGramScan/holocodescan";

////////////AMDMIN PANEL//////////////
import AdminCommon from "../Admin/admincommon";
import Upload from "../Admin/PosterData/uploaddata";
import PosterDataTable from "../Admin/PosterData/postertable";
import EditPoster from "../Admin/PosterData/EditPoster/editposter";
import ViewPoster from "../Admin/PosterData/ViewPoster/viewposter";
import AddPoster from "../Admin/PosterData/AddPoster/addposter";
import MusicScanner from "../Admin/QRFiles/musicscanner";
import Holoscanner from "../Admin/QRFiles/holoscanner";
import AvatarScanner from "../Admin/QRFiles/avatar";
import Zoneqr from "../Admin/QRFiles/zoneqr";
import Zone1 from '../User/Zone/ZonetablePoster/zone1';
import Zone2 from '../User/Zone/ZonetablePoster/zone2';
import Zone3 from '../User/Zone/ZonetablePoster/zone3';
import Zone4 from '../User/Zone/ZonetablePoster/zone4';
import Zone5 from '../User/Zone/ZonetablePoster/zone5';



const MainCommon = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/upload-info" element={<UploadInfo />} />
        <Route path="/scanner" element={<Scanner />} />
        <Route path="/zones" element={<ZoneSelection />} />
        <Route path="/music" element={<Music />} />
        <Route path="/aiartifacts" element={<AiArtifacts />} />
        <Route path="/wr" element={<WorldReligion />} />
        <Route path="/sanatandharma" element={<SanatanDharma />} />
        <Route path="/charlinchaplin" element={<CharlieChaplin />} />
        <Route path="/3d" element={<ThreeDVideos />} />
        <Route path="/steam" element={<Steam />} />
        <Route path="/danceform" element={<DanceForm />} />
        <Route path="/colours" element={<Colour />} />
        <Route path="/background" element={<Background />} />
        <Route path="/beats" element={<BeatsMusic />} />
        <Route path="/saar" element={<SaarMusic />} />
        <Route path="/zonetable" element={<ZoneTable />} />
        <Route path="/scanzone" element={<ZoneScan />} />
        <Route path="/codescanner" element={<CodeScanner />} />
        <Route path="/holocodescanner" element={<HolocodeScan />} />
        <Route path="/zone1" element={<Zone1 />} />
        <Route path="/zone2" element={<Zone2 />} />
        <Route path="/zone3" element={<Zone3 />} />
        <Route path="/zone4" element={<Zone4 />} />
        <Route path="/zone5" element={<Zone5 />} />

        {/* ✅ new admin route */}
        <Route path="/admincommon" element={<AdminCommon />} />
        <Route path="/adminupload" element={<Upload />} />
        <Route path="/posterdata" element={<PosterDataTable />} />
        <Route path="/editposter/:srno" element={<EditPoster/>} /> 
        <Route path="/viewposter/:srno" element={<ViewPoster/>} />
        <Route path="/addposter" element={<AddPoster/>} />     
        <Route path="/musicscanner" element={<MusicScanner />} />    
        <Route path="/holoscanner" element={<Holoscanner />} />  
        <Route path="/avatar" element={<AvatarScanner />} /> 
        <Route path="/zoneqr" element={<Zoneqr />} />    
        <Route
          path="*"
          element={
            <div>
              <h1>404 - Page Not Found</h1>
              <p>The page you're looking for does not exist.</p>
            </div>
          }
        />
      </Routes>
    </Router>
  );
};

export default MainCommon;
